module.exports = __webpack_public_path__ + "static/hero-image-landing-page-1ed683642be6fc27e736ee15f52cbefe.jpg";